import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#FFDA44\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#000\" d=\"M3.515 20.486q.757.755 1.604 1.347L21.834 5.12a12 12 0 0 0-2.952-2.952L2.168 18.882q.593.846 1.347 1.604\"></path><path fill=\"#6DA544\" d=\"M3.514 3.514C-.27 7.3-.998 12.985 1.332 17.5l16.17-16.169C12.986-.998 7.3-.272 3.514 3.514\"></path><path fill=\"#338AF3\" d=\"M20.484 20.485c3.785-3.785 4.512-9.471 2.181-13.987L6.496 22.667c4.516 2.33 10.202 1.604 13.987-2.182\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }